// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2Bic2","noInteraction":"EventWrapper_noInteraction__1vDmw","pointerPassthrough":"EventWrapper_pointerPassthrough__11Q-F"};